export const FORM_UUID_REQUEST = 'FORM_UUID_REQUEST'
export const FORM_OWNER_REQUEST = 'FORM_OWNER_REQUEST'

const initialState = {
  uuid: '',
  owner: null,
}

export default function form(state = initialState, { type, payload }) {
  switch (type) {
    case FORM_UUID_REQUEST:
      return {
        ...state,
        uuid: payload,
      }
    case FORM_OWNER_REQUEST:
      return {
        ...state,
        owner: payload,
      }
    default:
      return state
  }
}

export function setFormUUID(payload) {
  return {
    type: FORM_UUID_REQUEST,
    payload,
  }
}

export function setFormOwner(payload) {
  return {
    type: FORM_OWNER_REQUEST,
    payload,
  }
}
